/**
 * Default fontsize in pixels.
 */
export const fontSize = 16;
